import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Editable from "./Editabled/Editable";
import "./KanbanView.css";

import { CrmAction } from "../../Redux/Reducers/CrmSlice";
import {
  updateBoardTitle,
  addBoard,
  removeBoard,
  addCard,
  dragStart,
  dragEnd,
  dragOver,
  updateCard,
} from "../../Redux/Reducers/CrmSlice";
import Board from "../../Components/Kanban/Board/Board";
import { nameCreate } from "../../DataApi/name_create";
import { useSession } from "../../authentications/SessionContext";
import { unLink } from "../../DataApi/unlink";
import { enqueueSnackbar } from "notistack";

const KanbanView = ({
  handleLoadMore,
  handleCreateLead,
  handleSelectStageId,
  isModalOpen,
  handleCloseModal,
  handleRemoveCard,
}) => {
  const { sessionInfo } = useSession();
  const { company_id, context } = sessionInfo;
  const groupedBoards = useSelector((state) => state.crm.boards);
  const dispatch = useDispatch();

  const boardProps = {
    isModalOpen,
    handleCloseModal,
    handleSelectStageId,
    handleCreateLead,
    LoadMoreData: handleLoadMore,
    addCard: (stageId, title) => dispatch(addCard({ stageId, title })),
    updateBoardTitle: (stageId, newTitle) =>
      dispatch(updateBoardTitle({ stageId, newTitle })),
    removeBoard: async (stageId) => {
      let response = await unLink({
        id: stageId,
        company_id,
        context,
        model: "crm.stage",
      });
      response = JSON.parse(response);
      if (response?.result) {
        dispatch(removeBoard(stageId));
      }
      return response;
    },
    removeCard: handleRemoveCard,
    dragStart,
    dragEnd,
    dragOver,
    dropCard: (stageId) => {
      // console.log("Dropping card to boardId:", stageId);
      // dispatch(dropCard({ stageId }));
    },
    updateCard: (stageId, cardId, updatedCard) =>
      dispatch(updateCard({ stageId, cardId, updatedCard })),
  };

  useEffect(() => {
    localStorage.setItem("prac-kanban", JSON.stringify(groupedBoards));
  }, [groupedBoards]);

  const handleBoardCreation = async (name) => {
    let response = await nameCreate(name, context, company_id);
    response = JSON.parse(response);
    try {
      dispatch(addBoard({ ...response })); // Dispatch the addBoard action
    } catch (error) {}

    return response;
  };
  return (
    <div className="KanbanContainer">
      <div className="app_boards_container">
        <div className="app_boards">
          {Array.isArray(groupedBoards) ? (
            groupedBoards.map((board) => (
              <Board
                key={board.stage_id}
                stageId={board.stage_id}
                title={board.title}
                board={board}
                cards={board.cards}
                {...boardProps}
              />
            ))
          ) : (
            <div>Loading...</div>
          )}
          <div className="app_boards_last">
            <Editable
              displayClass="app_boards_add-board"
              editClass="app_boards_add-board_edit"
              placeholder="Enter Board Name"
              text="Add a Column"
              buttonText="Add Board"
              onSubmit={handleBoardCreation}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default KanbanView;
